<template>
  <v-container fluid class="home-page">
    <v-container class="home-content">
      <v-container class="mobile-logo-panel text-center d-md-none d-lg-none">
        <img src="@/assets/mtl-cargo-logo-2.png" class="mobile-logo" />
      </v-container>

      <v-container
        class="home-hero d-flex flex-wrap flex-md-nowrap flex-lg-nowrap"
      >
        <v-container
          class="rate-panel d-flex flex-wrap flex-md-nowrap flex-lg-nowrap"
        >
          <v-container class="rate-copy">
            <div class="home-eyebrow">Shipping Rates</div>
            <h1 class="home-title">BANG GIA</h1>
            <div class="rate-list">
              <div class="rate-row">
                <i class="fa-solid fa-map-pin"></i>
                <span>SAI GON:</span>
                <strong>$2.75/lbs</strong>
              </div>
              <div class="rate-row">
                <i class="fa-solid fa-map-pin"></i>
                <span>TINH:</span>
                <strong>$3.5/lbs</strong>
              </div>
            </div>
          </v-container>
          <v-container class="rate-image-wrap d-flex justify-center align-center">
            <img src="@/assets/background-1.jpg" class="rate-image" />
          </v-container>
        </v-container>

        <v-container fluid class="tracking-panel">
          <div class="section-title mb-3">Track Shipment</div>
          <v-container class="pa-0">
            <v-text-field
              class="mb-0"
              background-color="white"
              label="Tracking Number"
              dense
              rounded
              outlined
              filled
              v-model="tracking"
              v-on:keyup.enter="
                track = true;
                getShipmentStatus();
              "
            >
            </v-text-field>
            <v-btn
              block
              color="warning"
              rounded
              depressed
              :loading="isLoading"
              @click="
                track = true;
                getShipmentStatus();
              "
            >
              <i class="fa-solid fa-magnifying-glass mr-2"></i>Track
            </v-btn>
          </v-container>
          <v-expand-transition>
            <v-container
              v-if="track == true"
              class="tracking-result rounded-xl mt-3"
            >
              <v-container v-if="track == true">
                <v-timeline dense align-top v-if="statuses.length > 0">
                  <v-timeline-item
                    small
                    v-for="(item, idx) in statuses"
                    :key="idx"
                    color="deep-orange accent-2"
                  >
                    <v-container class="d-flex justify-space-around caption pa-0">
                      <div>{{ item.statusName }}</div>
                      <div class="caption">
                        {{ convertToUsDate(item.dateCreated) }}
                      </div>
                    </v-container>
                  </v-timeline-item>
                </v-timeline>
                <v-container
                  class="text-center muted-text"
                  v-if="statuses.length == 0 && track && !isLoading"
                >
                  <div class="empty-title">
                    <i class="fa-regular fa-face-frown"></i>
                    No Update!
                  </div>
                </v-container>
              </v-container>
            </v-container>
          </v-expand-transition>
        </v-container>
      </v-container>

      <v-container class="home-section">
        <v-container class="section-header">
          <h2>Our Services</h2>
        </v-container>
        <v-container
          class="service-grid d-flex justify-space-around flex-wrap flex-md-nowrap flex-lg-nowrap"
        >
          <v-card elevation="0" outlined class="service-card rounded-xl">
            <v-card-text class="text-center">
              <h3>Custom Orders</h3>
            </v-card-text>
            <v-card-text class="text-center">
              <img src="@/assets/service-1.jpg" />
            </v-card-text>
          </v-card>
          <v-card elevation="0" outlined class="service-card rounded-xl">
            <v-card-text class="text-center">
              <h3>Air Freight</h3>
            </v-card-text>
            <v-card-text class="text-center">
              <img src="@/assets/service-3.jpg" />
            </v-card-text>
          </v-card>
          <v-card elevation="0" outlined class="service-card rounded-xl">
            <v-card-text class="text-center">
              <h3>Sea Freight</h3>
            </v-card-text>
            <v-card-text class="text-center">
              <img src="@/assets/service-2.jpg" />
            </v-card-text>
          </v-card>
        </v-container>
      </v-container>

      <v-container class="home-section">
        <v-container class="section-header d-flex justify-space-between align-center">
          <h2>Our Products</h2>
          <v-btn
            rounded
            depressed
            color="primary"
            @click="$router.push({ name: 'PublicProducts' }).catch(() => {})"
          >
            See More
          </v-btn>
        </v-container>
        <vue-marquee-slider
          id="marquee-slider"
          :speed="speed"
          :width="200"
          :space="20"
          v-if="products.length > 0"
        >
          <product-card
            v-for="product in products"
            :key="`product-${product.id}`"
            :product="product"
            :clickable="false"
            :show-price="false"
          ></product-card>
        </vue-marquee-slider>
      </v-container>

      <v-container class="home-section contact-section">
        <v-container class="section-header">
          <h2>Contact Us</h2>
        </v-container>
        <v-container fluid class="contact-field py-0">
          <v-text-field
            :rules="nameRules"
            dense
            outlined
            rounded
            label="Fullname"
            v-model="contactUs.name"
          ></v-text-field>
        </v-container>
        <v-container fluid class="contact-field d-flex flex-wrap flex-md-nowrap py-0">
          <v-text-field
            :rules="phoneRules"
            class="contact-split-field"
            dense
            outlined
            rounded
            label="Phone"
            v-model="contactUs.phone"
          ></v-text-field>
          <v-text-field
            :rules="emailRules"
            dense
            outlined
            rounded
            label="Email"
            v-model="contactUs.email"
          ></v-text-field>
        </v-container>
        <v-container fluid class="contact-field py-0">
          <v-textarea
            :rules="textRules"
            rounded
            outlined
            dense
            label="Message"
            v-model="contactUs.message"
          ></v-textarea>
        </v-container>
        <v-container fluid class="contact-field">
          <v-btn
            v-if="!isSuccessful"
            block
            rounded
            depressed
            color="primary"
            :disabled="!enableSubmit"
            :loading="isLoading"
            @click="addContactUs"
          >
            <i class="fa-regular fa-paper-plane mr-2"></i>Submit
          </v-btn>
          <v-btn v-else block rounded depressed color="primary" disabled="true">
            <i class="fa-regular fa-paper-plane mr-2"></i>Submitted
          </v-btn>
        </v-container>
      </v-container>
    </v-container>
  </v-container>
</template>

<script>
import ProductCard from "@/components/ProductCard.vue";
import formMixin from "@/js/form-mixin";
import eventBus from "@/js/event-bus";
import backendService from "@/services/backend-service";

export default {
  name: "HomePage",
  components: {
    "product-card": ProductCard,
  },
  mixins: [formMixin],
  mounted: function () {
    this.getProducts();
  },
  data() {
    return {
      track: false,
      isLoading: false,
      isSuccessful: false,
      contactUs: { name: "", email: "", phone: "", message: "" },
      statuses: [],
      products: [],
      tracking: "",
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["isLoggedIn"];
    },
    enableSubmit() {
      return (
        this.contactUs.name &&
        this.contactUs.email &&
        this.contactUs.phone &&
        this.contactUs.message
      );
    },
    speed() {
      return (this.products.length * 20000) / 4;
    },
  },
  methods: {
    addContactUs() {
      this.isLoading = true;
      backendService
        .addContactUs(this.contactUs)
        .then(() => {
          setTimeout(() => {
            this.isLoading = false;
            this.isSuccessful = true;
            eventBus.$emit(
              "setSnackbar",
              "Successfully added your information",
              "success",
              true
            );
          }, 1000);
        })
        .catch(() => {
          setTimeout(() => {
            this.isLoading = false;
            eventBus.$emit(
              "setSnackbar",
              "Ops! something is not right",
              "error",
              true
            );
          }, 1000);
        });
    },
    convertToUsDate(val) {
      return new Date(val).toLocaleDateString("en-US");
    },
    getProducts() {
      backendService.getPublicProducts().then((response) => {
        this.products = response.data;
      });
    },
    getShipmentStatus() {
      this.isLoading = true;

      backendService
        .getShipmentStatusByTracking(this.tracking)
        .then((response) => {
          setTimeout(() => {
            this.statuses = response.data;
            this.isLoading = false;
          }, 1000);
        })
        .catch(() => {
          setTimeout(() => {
            this.isLoading = false;
          });
        });
    },
  },
};
</script>

<style scoped>
.home-page {
  color: #172033;
  padding: 18px 12px 28px;
}
.home-content {
  max-width: 1180px;
  padding: 0;
}
.mobile-logo-panel,
.home-section,
.rate-panel,
.tracking-panel {
  background-color: rgba(255, 255, 255, 0.94);
  border: 1px solid rgba(23, 32, 51, 0.08);
  box-shadow: 0 10px 28px rgba(23, 32, 51, 0.08);
}
.mobile-logo-panel {
  border-radius: 24px;
  margin-bottom: 10px;
  padding: 18px;
}
.mobile-logo {
  max-width: 260px;
  width: 80%;
}
.home-hero {
  gap: 12px;
  padding: 0;
}
.rate-panel,
.tracking-panel,
.home-section {
  border-radius: 24px;
}
.rate-panel {
  flex: 1 1 680px;
  gap: 12px;
  padding: 18px;
}
.tracking-panel {
  flex: 0 0 340px;
  max-width: 380px;
  padding: 18px;
}
.rate-copy {
  flex: 1 1 280px;
  padding: 0;
}
.home-eyebrow {
  color: #d95516;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0;
  margin-bottom: 6px;
  text-transform: uppercase;
}
.home-title {
  color: #172033;
  font-size: 32px;
  font-weight: 700;
  line-height: 1.15;
  margin: 0 0 18px;
}
.rate-list {
  display: grid;
  gap: 12px;
}
.rate-row {
  align-items: center;
  color: #26324a;
  display: flex;
  font-size: 18px;
  gap: 10px;
}
.rate-row i {
  color: #f05a28;
  font-size: 22px;
  width: 24px;
}
.rate-row strong {
  color: #111827;
  font-weight: 700;
}
.rate-image-wrap {
  flex: 1 1 300px;
  min-width: 0;
  padding: 0;
}
.rate-image {
  border-radius: 18px;
  display: block;
  max-height: 240px;
  object-fit: cover;
  width: 100%;
}
.section-title,
.section-header h2,
.service-card h3,
.empty-title {
  color: #172033;
  font-weight: 600;
  line-height: 1.25;
  margin: 0;
}
.section-title,
.section-header h2 {
  font-size: 22px;
}
.service-card h3,
.empty-title {
  font-size: 18px;
}
.tracking-result {
  background-color: #f7f9fc;
  padding: 8px;
}
.muted-text {
  color: #667085;
}
.home-section {
  margin-top: 14px;
  padding: 18px;
}
.section-header {
  padding: 0 0 14px;
}
.service-grid {
  gap: 12px;
  padding: 0;
}
.service-card {
  flex: 1 1 220px;
}
.service-card img {
  max-width: 140px;
  width: 48%;
}
.contact-section {
  max-width: 820px;
}
.contact-field {
  max-width: none;
  padding-left: 0;
  padding-right: 0;
}
.contact-split-field {
  margin-right: 10px;
}
@media (max-width: 959px) {
  .home-page {
    padding-top: 12px;
  }
  .tracking-panel {
    flex-basis: 100%;
    max-width: none;
  }
}
@media (max-width: 599px) {
  .home-title {
    font-size: 26px;
  }
  .rate-row {
    font-size: 16px;
  }
  .contact-split-field {
    margin-right: 0;
  }
}
</style>
